module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.getClassMobile(),
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "margin-top": "30px",
      "cursor": "pointer"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_category_name")) + ": " + _vm._s(_vm.categoryName))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "height": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newColor),
      expression: "newColor"
    }],
    staticClass: "form-control input",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_add_new_color'),
      "name": "Dodaj novi tip"
    },
    domProps: {
      "value": (_vm.newColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newColor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addNewColor()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus",
    staticStyle: {
      "font-size": "20px",
      "color": "white",
      "cursor": "pointer"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "height": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width",
    style: (_vm.tableStyle())
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "80%",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_color')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.colors), function(item) {
    return _c('tr', {
      staticStyle: {
        "color": "white"
      }
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_color')
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteColor(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                ")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "height": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.updateColors
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n          ")]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c95c49f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/SeeCategoryColors.vue
// module id = 825
// module chunks = 0